import { useState } from "react";
import "./works.scss";

export default function Works() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      icon: "./assets/writing.png",
      title: "AI / LLM & Agentic Systems",
      desc: "Building agentic workflows, RAG pipelines, and MCP servers that let AI agents like Claude and GitHub Copilot plan, retrieve live context, and autonomously execute multi-step tasks.",
      img: "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
    },
    {
      id: "2",
      icon: "./assets/mobile.png",
      title: "Mobile & AR Engineering",
      desc: "Shipping production iOS apps with SwiftUI, ARKit, RealityKit, and LiDAR for real-world AR scanning, alongside native Android and Kotlin development.",
      img: "https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg",
    },
    {
      id: "3",
      icon: "./assets/globe.png",
      title: "Full-Stack & Platform Engineering",
      desc: "Architecting RESTful APIs and microservices across Angular, React, and Node.js, with secure, scalable infrastructure on Azure and AWS.",
      img: "https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : data.length - 1)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };

  return (
    <div className="works" id="works">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className="container" key={d.id}>
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <div className="imgContainer">
                    <img src={d.icon} alt={`${d.title} icon`} />
                  </div>
                  <h2>{d.title}</h2>
                  <p>{d.desc}</p>
                  <a href="#portfolio">
                    <span>Projects</span>
                  </a>
                </div>
              </div>
                <div className="right">
                  <img src={d.img} alt={`${d.title} preview`} />
                </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt="Previous slide"
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt="Next slide"
        onClick={() => handleClick()}
      />
    </div>
  );
}
